// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__L6Qds","card":"dashboard_card__fjfZ2"};